import { Expose, Type } from 'class-transformer';

class SocialMediaShareWidgetOption {
  @Expose()
  id!: string;

  @Expose()
  label!: string;

  @Expose()
  type!: string;

  @Expose()
  to!: string;
}

export class SocialMediaShareProps {
  @Expose()
  label!: string | null;

  @Expose()
  useNativeShareApi!: boolean;

  @Expose()
  @Type(() => SocialMediaShareWidgetOption)
  options!: SocialMediaShareWidgetOption[];
}
